<my-bill-odb-explanation-intro
  [billExplanationType]="billExplanationType"
  *ngIf="billExplanationType"
></my-bill-odb-explanation-intro>
